import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import Icon from '../../components/Icon';
import Input from '../../components/Input';
import Segment from '../../components/Segment';

import './styles.css';

export const messages = defineMessages({
  searchPlaceholder: {
    id: 'repvisits.contacts.search.placeholder',
    defaultMessage: '...search for an institution.',
  },
});

const ListHeader = ({ intl, searchValue, onSearchChange }) => {
  const searchPlaceholder = intl.formatMessage(messages.searchPlaceholder);
  return (
    <Segment styleName="contacts-container-header">
      <Input
        icon
        className="visible-mobile-flex"
        styleName="contacts-search"
        value={searchValue}
        onChange={onSearchChange}
      >
        <Icon name="search" />
        <input
          data-cy="contacts-search"
          type="text"
          name="contacts-search"
          aria-label={searchPlaceholder}
          placeholder={searchPlaceholder}
        />
      </Input>
    </Segment>
  );
};

ListHeader.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  searchValue: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

export default injectIntl(ListHeader);
